import React from 'react';
import { motion } from 'motion/react';
import { useNavigate } from 'react-router-dom';
import {
  ClockIcon,
  TargetIcon,
  ChevronRightIcon,
} from '@radix-ui/react-icons';
import { Button } from '../common/Button';
import { Card, CardContent } from '../common/Card';
import { formatDuration, toHumanReadableTime } from '../../utils/time';

const ActivityCard = ({ activity, onTimerToggle }) => {
  const navigate = useNavigate();
  const isRunning = activity.in_progress;

  const handleDetailsClick = (e) => {
    e.stopPropagation(); // Prevent card click from triggering
    navigate(`/activity/${activity.id}/view`);
  };

  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95 }}
      whileHover={{ y: -2 }}
      transition={{ duration: 0.2 }}
      onClick={() => onTimerToggle(activity.id)}
      className="cursor-pointer"
    >
      <Card className={`hover-card overflow-hidden h-[160px] ${isRunning ? 'border-green-500/50 shadow-[0_0_10px_rgba(34,197,94,0.1)]' : ''}`}>
        <CardContent className="p-6 h-full flex flex-col">
          <div className="flex items-start justify-between mb-4">
            <div className="space-y-1">
              <h3 className="font-semibold tracking-tight line-clamp-1 flex items-center gap-2">
                {activity.name}
                {isRunning && (
                  <span className="inline-flex h-2 w-2 rounded-full bg-green-500 animate-pulse" />
                )}
              </h3>
              <div className="flex items-center text-sm text-muted-foreground">
                <ClockIcon className="mr-1 h-6 w-4 flex-shrink-0" />
                {formatDuration(activity.total_duration_in_minutes)}
              </div>
            </div>
            <Button
              variant="ghost"
              size="sm"
              className="text-sm flex-shrink-0"
              onClick={handleDetailsClick}
            >
              Details
              <ChevronRightIcon className="ml-1 h-4 w-4" />
            </Button>
          </div>

          <div className="flex flex-col gap-2 text-sm text-muted-foreground mt-auto">
              <div className="flex items-center">
                {activity.thirty_day_challenge_is_active && (
                  <>
                    <TargetIcon className="mr-1 h-4 w-4 flex-shrink-0" />
                    30 Days Challenge
                  </>
                )}
                {activity.last_updated_date && (
                  <div className="text-xs ml-auto text-muted-foreground/40">
                    {toHumanReadableTime(activity.last_updated_date)}
                  </div>
                )}
            </div>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default ActivityCard; 